// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1nzgf","productName":"Table_productName__3XT9R"};